import { useFormStore } from '../../../../../../../store/use-form-store';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useInputLangStore } from '../../../../../../../store/use-input-lang-store';
import { FormElementType } from '../../../../../../../store/api/forms-api';
import { Checkbox } from '../../../../../../../components/checkbox/checkbox';

interface Props {
  formElement?: Partial<FormElementType>;
}

export const FormCreateCheckbox = ({ formElement }: Props) => {
  const { getLocale } = useLang();
  const { newElement } = useFormStore();
  const { language } = useInputLangStore();

  const helperText = formElement ? formElement.info?.helper_text : newElement?.info?.helper_text;
  const helper = formElement ? formElement.info?.helper : newElement?.info?.helper;

  return <Checkbox label={helper === 'sublabel' ?  getLocale(helperText, language) : undefined} />;
};
